export const GET_ADMINDATAISSUEMAINTENANCEMODE_ABORTED =
  'GET_ADMINDATAISSUEMAINTENANCEMODE_ABORTED';
export const GET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED =
  'GET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED';
export const GET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED =
  'GET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED';
export const GET_ADMINDATAISSUEMAINTENANCEMODE_FAILED =
  'GET_ADMINDATAISSUEMAINTENANCEMODE_FAILED';

export const SET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED =
  'SET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED';
export const SET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED =
  'SET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED';
export const SET_ADMINDATAISSUEMAINTENANCEMODE_FAILED =
  'SET_ADMINDATAISSUEMAINTENANCEMODE_FAILED';

export const GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_ABORTED =
  'GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_ABORTED';
export const GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_REQUESTED =
  'GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_REQUESTED';
export const GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_COMPLETED =
  'GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_COMPLETED';
export const GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_FAILED =
  'GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_FAILED';
